<template>
  <div class="logo-wrapper">
    <div :class="{'mobile': textInMobile}" class="logo name">
      <!-- <RouterLink :to="`/${$i18n.localePath()}`" class="container">
        <img :src="logoImagePath" :title="logoAlternative" :alt="logoAlternative">
      </RouterLink> -->
      <a v-if="$production.toUpperCase() !== 'AIR'" target="_blank" rel="noopener noreferrer" :href="AIR_URL" class="link" @click="navOnClick(AIR_URL)">
        <img :src="logoImagePath" :title="logoAlternative" :alt="logoAlternative">
      </a>
      <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}" class="link">
        <img :src="logoImagePath" :title="logoAlternative" :alt="logoAlternative">
      </RouterLink>
    </div>
    <div :class="{'mobile': !textInMobile}" class="logo disc">
      <RouterLink :to="`/${$i18n.localePath()}`" class="container">
        <img :title="logoAlternative" :alt="logoAlternative" src="@/assets/images/img-turntable/img-turntable-s.png">
      </RouterLink>
    </div>
    <!-- <span class="beta">
      Beta
    </span> -->
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    url: {
      type: String,
      default: undefined
    },
    textInMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logoName: ''
    }
  },
  computed: {
    logoImagePath() {
      // const logoFileName = this.logoName.toLowerCase() === 'air' ? 'logo-muzikair' : 'logo-muzikair' + this.logoName.toLowerCase()
      const logoFileName = 'logo-muzikair'
      return require(`@/assets/images/logo/${logoFileName}.svg`)
    },
    logoAlternative() {
      return this.logoName.toLowerCase() === 'air' ? 'MUZIK AIR' : 'MUZIK AIR ' + this.logoName.toUpperCase()
    },
    AIR_URL() {
      return `https://${process.env.VUE_APP_MUZIK_AIR}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    }
  },
  created() {
    this.logoName = this.$production || 'air'
  },
  mounted() {},
  methods: {
    navOnClick(url) {
      this.$store.dispatch('GTAG_EVENT', {
        action: 'click',
        data: {
          event_category: 'outbound',
          event_label: url,
          transport_type: 'beacon',
          event_callback: function () {
            // document.location = url
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-wrapper{
  position: relative;
  display: inline-block;
  margin-right: 12px;
  .beta {
    // display: inline-block;
    position: absolute;
    right: 0;
    bottom: 15px;
    color: #c2c2c2;
    font-size: 12px;
    padding: 0 4px;
  }
}
.logo.name {
  display: inline-block; // default, update in query media
  vertical-align: top;
  height: 64px;
  padding-top: 17px;
  padding-bottom: 17px;
  line-height: normal; // reset inherent effect
  cursor: pointer;
  img {
    vertical-align: middle;
    height: 30px;
  }
}
.logo.disc {
  display: none; // default, update in query media
  vertical-align: top;
  height: 64px;
  padding-top: 14px;
  padding-bottom: 14px;
  line-height: normal; // reset inherent effect
  cursor: pointer;
  img {
    vertical-align: middle;
    height: 36px;
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .logo.name:not(.mobile) {
    display: none;
  }
  .logo.disc.mobile {
    display: inline-block;
  }
}

@media only screen and (max-width: 767.98px) {
  .logo.name.mobile {
    padding-top: 20px;
    padding-bottom: 20px;
    img {
      vertical-align: middle;
      height: 23px;
    }
  }
  .logo.name:not(.mobile) {
    display: none;
  }
  .logo.disc.mobile {
    display: inline-block;
  }
}
</style>
